import { Collapse } from "antd";
import React from "react";
import { usePendingRequests } from "../../modules/PendingApprovalRequets/api/usePendingRequests ";
import ApprovalCard from "./ApprovalCard";
import { approvalCollapseStyles } from "./style/style";

const { Panel } = Collapse;

const ApprovalCollapse: React.FC<{ isPendingApprovalEnabled?: boolean; isReceiptModuleEnabled?: boolean }> = ({ isPendingApprovalEnabled, isReceiptModuleEnabled }) => {
  const { data } = usePendingRequests();

  return (
    <Collapse
      accordion
      bordered={false}
      // loading={isLoading}
      className="approval-collapse"
      style={approvalCollapseStyles.collapse}
      expandIconPosition="end"
    >
      {data?.map(
        (group) =>
          group.items?.length > 0 && (
            <Panel
              key={group.id}
              header={group.title + ` - ${group.items?.length}`}
              style={approvalCollapseStyles.panel}
            >
              {/* Cards inside each collapse */}
              <div style={approvalCollapseStyles.panelContent}>
                {group.items.map((item) => (
                  <ApprovalCard isPendingApprovalEnabled={isPendingApprovalEnabled} isReceiptModuleEnabled={isReceiptModuleEnabled} key={item.id} item={item} />
                ))}
              </div>
            </Panel>
          ),
      )}
    </Collapse>
  );
};

export default ApprovalCollapse;
